import s from "./td-longtail-vue-components126.js";
import p from "./td-longtail-vue-components98.js";
var a = function() {
  var r = this, t = r._self._c, n = r._self._setupProxy;
  return t(n.InputWrapper, r._b({ scopedSlots: r._u([{ key: "default", fn: function({ id: e }) {
    return [t("input", r._b({ ref: "primaryInput", staticClass: "input-wrapper__input", class: r.inputClass, attrs: { id: e, "aria-invalid": !!r.errorMessage, "aria-describedby": `${e}-error` }, on: { input: n.onInput, focus: n.onFocus } }, "input", n.inputFieldProps, !1))];
  } }]) }, "InputWrapper", n.inputWrapperProps, !1));
}, i = [], o = /* @__PURE__ */ p(
  s,
  a,
  i,
  !1,
  null,
  null
);
const f = o.exports;
export {
  f as default
};
